import React, { useMemo, useEffect, useRef } from 'react';
import gsap from 'gsap';

function SparklingStars({ seed }) {
  const containerRef = useRef(null);
  const starsRef = useRef([]);

  // Star configuration
  const stars = useMemo(() => {
    const count = 25;
    return Array.from({ length: count }, () => ({
      size: Math.random() * 2 + 1, // 1-3px
      baseOpacity: Math.random() * 0.4 + 0.3, // 0.3-0.7
      animationDuration: Math.random() * 3 + 4 // 4-7 seconds
    }));
  }, [seed]);

  const animateStar = (starElement, starConfig) => {
    const tl = gsap.timeline({ repeat: -1 });
    
    // Initial setup
    gsap.set(starElement, {
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      opacity: starConfig.baseOpacity
    });

    // Animation sequence
    tl.to(starElement, {
      opacity: 0,
      duration: starConfig.animationDuration * 0.4,
      ease: "sine.inOut"
    })
    .to(starElement, {
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      duration: 0.1,
      immediateRender: false
    })
    .to(starElement, {
      opacity: starConfig.baseOpacity,
      duration: starConfig.animationDuration * 0.6,
      ease: "sine.inOut",
      delay: Math.random() * 1.5
    });

    return tl;
  };

  useEffect(() => {
    const ctx = gsap.context(() => {
      starsRef.current.forEach((starElement, index) => {
        const tl = animateStar(starElement, stars[index]);
        tl.progress(Math.random()); // Random start position
      });
    }, containerRef);

    return () => ctx.revert();
  }, [stars]);

  return (
    <div
      ref={containerRef}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 1,
      }}
    >
      {stars.map((star, i) => (
        <div
          key={i}
          ref={el => starsRef.current[i] = el}
          className="star"
          style={{
            position: 'absolute',
            width: `${star.size}px`,
            height: `${star.size}px`,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderRadius: '50%',
            filter: 'blur(0.5px)',
            willChange: 'opacity, top, left'
          }}
        />
      ))}
    </div>
  );
}

export default SparklingStars;